import { Controller } from "stimulus";
import 'select2';
import 'select2/dist/css/select2';
import '../entrypoints/src/admin/components/link_to_add_row';
import BootstrapNavTabs from "../entrypoints/src/admin/components/bootstrap_nav_bars";

export default class extends Controller {
  connect() {
    this.$cbAdvancedFields = this.element.querySelector('#advanced-fields-check');
    !!this.$cbAdvancedFields && this.$cbAdvancedFields.addEventListener('click', () => $('#advanced-person-fields').collapse('toggle'));

    $(this.element.querySelector("#extra-info-modal")).on('hide.bs.modal', () => {
			let content = this.element.querySelector('#extra-info-person').value;
			this.element.querySelector('#pre-extra-info').innerHTML = content.length == 0 ? 'Nenhuma observação feita' : content;
		});

    const trNav = this.element.querySelector('.tr-nav');
    if (trNav) BootstrapNavTabs.mergeCustomFeatures(trNav);

    this.navLinkFinancial = this.element.querySelector('.nav-link#financial');
    if (this.navLinkFinancial) {
      this.navLinkFinancial.addEventListener('click', () => this.loadFinancialFrame());
      this.navLinkFinancial.classList.contains('active') && this.loadFinancialFrame();
    }
  }

  loadFinancialFrame() {
    if (!!this.navLinkFinancial.dataset.clicked) return;

    this.navLinkFinancial.dataset.clicked = 'true';
    document.querySelector('#turbo-frame__person-financial').setAttribute('src', this.navLinkFinancial.dataset.src);
  }
};
